module.exports = __webpack_public_path__ + "img/bee006.9d31ca7f.svg";